import React from "react";
import { IoIosArrowRoundForward } from "react-icons/io";
import ProductCard from "./ProductCard";
import productImg1 from "../../assets/images/skinefit/imgs/Artboard 1.jpg";
import productImg2 from "../../assets/images/skinefit/imgs/Artboard 2.jpg";
import productImg4 from "../../assets/images/skinefit/imgs/Artboard 3.jpg";
import productImg5 from "../../assets/images/skinefit/imgs/Artboard 4.jpg";
import productImg6 from "../../assets/images/skinefit/imgs/Artboard 6.jpg";
import productImg7 from "../../assets/images/skinefit/imgs/Artboard 7.jpg";
import productImg8 from "../../assets/images/skinefit/imgs/Artboard 8.jpg";
import productImg9 from "../../assets/images/skinefit/imgs/Artboard 9.jpg";
import productImg10 from "../../assets/images/skinefit/imgs/Artboard 17.jpg";

const ProductList = () => {
  const products = [
    {
      img: productImg1,
      title: "Product",
      price: 100,
    },
    {
      img: productImg2,
      title: "Product",
      price: 120,
    },
    {
      img: productImg4,
      title: "Product",
      price: 200,
    },
    {
      img: productImg5,
      title: "Product",
      price: 146,
    },

    {
      img: productImg6,
      title: "Product",
      price: 167,
    },
    {
      img: productImg7,
      title: "Product",
      price: 105,
    },
    {
      img: productImg8,
      title: "Product",
      price: 100,
    },
    {
      img: productImg9,
      title: "Product",
      price: 146,
    },

    {
      img: productImg10,
      title: "Product",
      price: 146,
    },
  ];
  return (
    <div className="mx-10 lg:mx-10">
      {/* Products  */}
      <div className="py-10">
        <div className="flex items-center justify-between w-full mb-10">
          <h1 className="text-2xl font-extralight  tracking-widest">
            Products
          </h1>
          <div className="flex items-center gap-1 cursor-pointer">
            <p className="font-extralight text-sm">View all</p>
            <IoIosArrowRoundForward />
          </div>
        </div>
        <div className="grid grid-cols-1  md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-10">
          {products.map((p) => (
            <ProductCard
              key={p.img}
              img={p.img}
              title={p.title}
              price={p.price}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default ProductList;
